import { SEARCH_RESULT_CONTENT_TYPE, SEARCH_RESULT_TYPE, SearchResult } from '~/types/search'
import { buildOperationHash } from '~/utils/api'
import { sanitizeId } from '~/utils/shared/content'

export const buildBreadcrumbsData = ({ productName, tileKey, parents = [], title }: { productName: string, tileKey: string, parents?: string[], title: string }) => {
  const product = {
    title: productName, id: sanitizeId(`product-${productName}-${tileKey}`)
  }
  const parentsArr = parents.map(parent => ({ title: parent, id: sanitizeId(`parent-${parent}-${tileKey}`) }))
  const page = { title: title, id: sanitizeId(`page-${title}-${tileKey}`) }
  return [
    product,
    ...parentsArr,
    page
  ]
}

export const getSearchResultUrl = (item: SearchResult) => {
  if (item.contentType === SEARCH_RESULT_CONTENT_TYPE.GRAPH_QL && item.resultType !== SEARCH_RESULT_TYPE.API) {
    return `/${item.product.slug}/${item.href}#${item.graphqlComponentAnchorId}`
  }
  if (item.resultType === SEARCH_RESULT_TYPE.OPERATION) {
    const operationHash = buildOperationHash(item)
    return `/${item.product.slug}/${item.href}${operationHash}`
  }
  if (item.resultType === SEARCH_RESULT_TYPE.SCHEMA && item.schemaName) {
    return `/${item.product.slug}/${item.href}#/${(item.schemaTitle || item.schemaName)}`
  }
  return `/${item.product.slug}/${item.href}`
}